document
  .querySelectorAll<HTMLElement>("[data-golden-campaign-button]")
  .forEach(button => {
    button
      .querySelectorAll<HTMLElement>("[data-animated-text-segment]")
      .forEach(textSegment => {
        // Set the width to be fixed to facilitate animation
        textSegment.style.width = `${textSegment.clientWidth}px`;
      });
  });
